import { combineReducers } from 'redux';
import invitationReducer from './invitationReducer';
import errorReducer from './errorReducer';
import authReducer from './authReducer';
import profileReducer from './profileReducer';
import userReducer from './userReducer';
import lessonReducer from './lessonReducer';
import courseReducer from './courseReducer';
import programReducer from './programReducer';
import pathReducer from './pathReducer';
import groupReducer from './groupReducer';
import questionReducer from './questionReducer';
import onboardingReducer from './onboardingReducer';
import eventReducer from './eventReducer';
import submissionFormReducer from './submissionFormReducer';
import submissionReducer from './submissionReducer';
import tagReducer from './tagReducer';
import reinforcementReducer from './reinforcementReducer';
import xpReducer from './xpReducer';
import dataImportExportReducer from './dataImportExportReducer';
import messageReducer from './messageReducer';
import termsConditionsReducer from './termsConditionsReducer';
import notificationReducer from './notificationReducer';
import badgeReducer from './badgeReducer';
import mondayReducer from './mondayReducer';
import tierReducer from './tierReducer';
import referralReducer from './referralReducer';

export default combineReducers({
  invitation: invitationReducer,
  error: errorReducer,
  auth: authReducer,
  profile: profileReducer,
  user: userReducer,
  lesson: lessonReducer,
  course: courseReducer,
  program: programReducer,
  path: pathReducer,
  group: groupReducer,
  question: questionReducer,
  onboarding: onboardingReducer,
  event: eventReducer,
  submissionForm: submissionFormReducer,
  submission: submissionReducer,
  tag: tagReducer,
  reinforcement: reinforcementReducer,
  xp: xpReducer,
  dataImportExport: dataImportExportReducer,
  termsConditions: termsConditionsReducer,
  message: messageReducer,
  notification: notificationReducer,
  badge: badgeReducer,
  monday: mondayReducer,
  tier: tierReducer,
  referral: referralReducer
});
